export const authScreens = {
  accesoDirecto: {
    loading: "Connexion à votre compte…",
  },
  confirmar: {
    verifying: "Vérification du compte…",
    verifiedSuccess: "Compte vérifié avec succès",
    tokenInvalid: "Le jeton n'existe pas ou a déjà expiré",
    backHome: "Retour à l'accueil",
  },
  recovery: {
    title: "Réinitialiser le mot de passe",
    successTitle: "Réussi !",
    successDesc:
      "Votre mot de passe a été modifié avec succès. Redirection vers l'accueil…",
    infoTitle: "Créez un nouveau mot de passe",
    infoDesc:
      "Le modifier déconnectera toutes les sessions actives sur vos autres appareils.",
    newPasswordLabel: "Nouveau mot de passe",
    newPasswordPlaceholder: "Saisissez votre nouveau mot de passe",
    togglePasswordAria: "Afficher/masquer le mot de passe",
    confirmPasswordLabel: "Répétez le mot de passe",
    confirmPasswordPlaceholder: "Répétez votre nouveau mot de passe",
    passwordsMismatch: "Les mots de passe ne correspondent pas.",
    submit: "Modifier le mot de passe",
    submitting: "Traitement en cours…",
    backToStart: "Retour à l'accueil",
    footerWeb: "Site web",
    toastInvalidLink: "Le lien de récupération est invalide ou a expiré.",
    errorGeneric: "Nous n'avons pas pu modifier le mot de passe.",
  },
};
